export class DurationJs {
    start: number;

    constructor() {
        this.start = performance.now();
    }

    elapsedMillis() {
        return performance.now() - this.start;
    }
}